import React, { useState, useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { Type } from 'react-bootstrap-table2-editor';
import { unixTimestampToDate } from '../../../../ressources/functionJS/unixTimestampToDate';
import { FloatChampInput } from '../../../../ressources/functionJS/FloatChampInput';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import styles from './TableauComposante.module.scss';

const TableauComposante = ({ component_list: propComponentList }) => {
  const [tableState, setTableState] = useState({
    component_list: [],
    incre: 0,
  });

  // Columns configuration - moved outside state since it's static
  const columns = [
    {
      dataField: 'component_id',
      text: checkMot('composante_id'),
      hidden: true,
      sort: true,
    },
    {
      dataField: 'position_in_sensor',
      text: checkMot('position_in_sensor'),
      sort: true,
    },
    {
      dataField: 'forumula',
      text: checkMot('forumula'),
      sort: true,
      editor: { type: Type.TEXTAREA },
    },
    { dataField: 'prefix', text: checkMot('prefix'), sort: true },
    { dataField: 'engineering_unit', text: checkMot('unite'), sort: true },
    {
      dataField: 'precision_decimal_notation',
      text: checkMot('resolution_decimales'),
      sort: true,
      formatter: FloatChampInput,
    },
    {
      dataField: 'start_formula',
      text: checkMot('start_formula'),
      sort: true,
      formatter: unixTimestampToDate,
    },
    {
      dataField: 'end_formula',
      text: checkMot('end_formula'),
      sort: true,
      formatter: unixTimestampToDate,
    },
    {
      dataField: 'calibration_factors',
      text: checkMot('calibration_factors'),
      sort: true,
    },
    { dataField: 'y_scale', text: checkMot('y_scale'), sort: true },
    { dataField: 'time_period', text: checkMot('time_period'), sort: true },
    { dataField: 'measures_num', text: checkMot('measures_num'), sort: true },
    { dataField: 'serial_number', text: checkMot('serial_number'), sort: true },
    { dataField: 'coordinate_x', text: checkMot('coordinate_x'), sort: true },
    { dataField: 'coordinate_y', text: checkMot('coordinate_y'), sort: true },
    { dataField: 'coordinate_z', text: checkMot('coordinate_z'), sort: true },
    {
      dataField: 'alarmlevel_high4',
      text: checkMot('alarmlevel_high4_black'),
      sort: true,
    },
    {
      dataField: 'alarmlevel_high3',
      text: checkMot('alarmlevel_high3_red'),
      sort: true,
    },
    {
      dataField: 'alarmlevel_high2',
      text: checkMot('alarmlevel_high2_amber'),
      sort: true,
    },
    {
      dataField: 'alarmlevel_high1',
      text: checkMot('alarmlevel_high1_blue'),
      sort: true,
    },
    {
      dataField: 'alarmlevel_low1',
      text: checkMot('alarmlevel_low1_blue'),
      sort: true,
    },
    {
      dataField: 'alarmlevel_low2',
      text: checkMot('alarmlevel_low2_amber'),
      sort: true,
    },
    {
      dataField: 'alarmlevel_low3',
      text: checkMot('alarmlevel_low3_red'),
      sort: true,
    },
    {
      dataField: 'alarmlevel_low4',
      text: checkMot('alarmlevel_low4_black'),
      sort: true,
    },
    { dataField: 'time_refresh', text: checkMot('time_refresh'), sort: true },
  ];

  useEffect(() => {
    setTableState((prevState) => ({
      ...prevState,
      component_list: propComponentList,
    }));
  }, [propComponentList]);

  return (
    <>
      <BootstrapTable
        striped
        hover
        keyField="component_id"
        data={tableState.component_list}
        columns={columns}
        classes={styles.TableauBootstrap}
        rowStyle={{ margin: '0px', color: 'black' }}
      />
    </>
  );
};

export default TableauComposante;
